<mat-dialog-content cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="dialog-ho-image">
    <div class="content-dialog">
        <div class="div-title">
            <mat-label class="label-title">Imagen de {{titleDialog}}</mat-label>
            <button class="close-button" mat-button mat-dialog-close aria-label="Cerrar">
                <mat-icon class="material-icons-outlined">cancel</mat-icon>
            </button>
        </div>
        
        <div class="div-image">
            <img src="{{dhoApiUrl}}/{{imageDialog.imagePath}}" alt="{{imageDialog.imageDescription}}" class="ho-image">
            <fieldset class="fieldset-label">
                <mat-label class="label-desription">
                    {{imageDialog.imageDescription}}
                </mat-label>
            </fieldset>
            
        </div>
        
    </div>
    
</mat-dialog-content>
